// (c) Copyright Mimic Networks, Inc. 2024
//
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../../config/tailwind.config.js'

const { theme } = resolveConfig(tailwindConfig)

export default theme
